module.exports = __webpack_public_path__ + "img/graph.d2fbe730.png";